import { render, staticRenderFns } from "./commonRow.vue?vue&type=template&id=09a95326&scoped=true"
import script from "./commonRow.vue?vue&type=script&lang=js"
export * from "./commonRow.vue?vue&type=script&lang=js"
import style0 from "./commonRow.vue?vue&type=style&index=0&id=09a95326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a95326",
  null
  
)

export default component.exports